import axios from 'axios'

export default {
    namespaced: true,
    state: {
        isMenuVisible: false,
        user: {
            email:'',
            nickname:'',
            logged: false
        },
    },
    getters: {
        /* User */
        user(state) {
            return state.user
        },
    },
    mutations: {
        setUser(state, user) {
            state.user = {
                ...user,
                logged: (user)
            }
            if(user) {
                axios.defaults.headers.common['Authorization'] = `bearer ${user.token}`
                state.isMenuVisible = true
            } else {
                delete axios.defaults.headers.common['Authorization']
                state.isMenuVisible = false
            }
        },
        toggleMenu(state, isVisible) {
            if(!state.user) {
                state.isMenuVisible = false
                return
            }

            if(isVisible === undefined) {
                state.isMenuVisible = !state.isMenuVisible
            } else {
                state.isMenuVisible = isVisible
            }
        }
    }
}